import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/stores/auth-store';

/**
 * Landing route for `/login/impersonate`. By the time React renders, the
 * impersonation-bootstrap module (imported first in main.tsx) has already
 * seeded the per-tab sessionStorage auth session and stripped the token from
 * the URL. This component just forwards into the app once the store reports
 * authenticated; otherwise it shows a brief loading state.
 */
export function ImpersonateConsumer() {
  const { t } = useTranslation();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
      {t('common.loggingIn')}
    </div>
  );
}
